import React from "react";
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";

import Makeup1 from "../Assets/Makeup1.jpeg";
import Makeup2 from "../Assets/Makeup2.jpeg";
import Makeup3 from "../Assets/Makeup3.jpeg";
import Makeup4 from "../Assets/Makeup4.jpeg";
import Makeup5 from "../Assets/Makeup5.jpeg";
import Makeup6 from "../Assets/Makeup6.jpeg";
import Makeup7 from "../Assets/Makeup7.jpeg";
import Hair1 from "../Assets/Hair1.jpeg";
import Hair2 from "../Assets/Hair2.jpeg";
import Hair3 from "../Assets/Hair3.jpeg";
import Hair4 from "../Assets/Hair4.jpeg";
import Hair5 from "../Assets/Hair5.jpeg";

const services = [
  { name: "Regal HD Bridal Makeup", description: "A stunning, high-definition makeup application featuring a flawless base, defined eyes, and rich lip tone, perfectly complemented by heavy traditional jewelry for a magnificent bridal look.", image: Makeup1 },
  { name: "Groom Dapper Look", description: "A meticulously finished, long-lasting natural-finish makeup for the groom, ensuring a refined and camera-ready appearance that complements the intricate traditional attire.", image: Makeup2 },
  { name: "Pastel Engagement Glam", description: "A soft, ethereal glam look featuring a pop of colored eyeliner, dewy skin, and nude lips, ideal for a contemporary engagement or cocktail party to perfectly match a pastel outfit.", image: Makeup3 },
  { name: "Smokey Eye Reception Glam", description: "Intense smokey eyes paired with a nude glossy lip and radiant skin, creating an elegant and striking evening party makeup look that shines with sequined or sheer outfits.", image: Makeup4 },
  { name: "Classic Saree Look", description: "A classic, elevated makeup look with a soft contour, subtle glow, and defined features, perfect for a traditional event or a celebratory look in a rich-colored saree.", image: Makeup5 },
  { name: "Jewel-Toned Festive Makeup", description: "A gorgeous look featuring defined eyes, warm glow, and a flattering pinkish-nude lip, designed to be versatile for any festive occasion or family celebration with rich fabric details.", image: Makeup6 },
  { name: "Subtle & Natural Makeup", description: "A fresh, minimal makeup application focusing on a clean base, soft eyes, and natural lip color, making it the perfect choice for outdoor or daytime functions like a pooja or intimate gathering.", image: Makeup7 },
  { name: "Bridesmaid Special", description: "An elegant updo adorned with pearls or florals — effortlessly graceful for bridesmaids.", image: Hair1 },
  { name: "Gypsy Messy Curls", description: "Boho-chic curls with soft bounce and texture, perfect for a carefree elegant vibe.", image: Hair2 },
  { name: "Haldi Mehendi Special", description: "Vibrant hairstyle with florals and waves — perfect for colorful celebrations.", image: Hair3 },
  { name: "Traditional Paradi Braid", description: "Beautifully woven braid with accessories and florals for a timeless, cultural charm.", image: Hair4 },
  { name: "Aesthetic Accessories Hairdo", description: "Graceful hairstyle enhanced with pearls or pins — soft, luxurious, and stunning.", image: Hair5 },
];

const ServicesPage = () => {
  return (
    <Box
      sx={{
        minHeight: "85vh",
        mt: "10vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        px: { xs: 2, sm: 4, md: 0 },
      }}
    >
      <Box
        sx={{
          bgcolor: "#1E412D",
          color: "#F5EDE3",
          borderRadius: { xs: 0, md: "12px" },
          textAlign: "justify",
          boxSizing: "border-box",
          px: { xs: "10px", sm: "20px", md: "60px" },
          py: { xs: 5, sm: 7, md: 10 },
          mt: "30px",
          mx: { xs: 0, md: "80px" },
          width: { xs: "100%", sm: "100%", md: "calc(100% - 160px)" },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontFamily: "Playfair Display, serif",
            fontWeight: 700,
            textAlign: "center",
            mb: 6,
            color: "#F5EDE3",
            fontSize: { xs: "2rem", sm: "3rem", md: "3.8rem", lg: "4rem" },
            lineHeight: 1.2,
          }}
        >
          Our Services
        </Typography>

        <Grid
          container
          spacing={{ xs: 3, sm: 4, md: 5 }}
          justifyContent="center"
          alignItems="stretch"
        >
          {services.map((service, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  backgroundColor: "rgba(255,255,255,0.08)",
                  color: "#fff",
                  borderRadius: "16px",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: {
                    xs: 320, 
                    sm: 280, 
                    md: 290, 
                    lg: 320, 
                  },
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.5)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={service.image}
                  alt={service.name}
                  sx={{
                    height: { xs: 200, sm: 200, md: 210, lg: 230 },
                    width: "100%",
                    objectFit: "contain",
                    objectPosition: "center top",
                  }}
                />
                <CardContent sx={{ flexGrow: 1, textAlign: "center", p: 2 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      fontFamily: "Lora, serif",
                      textAlign: "center",
                    }}
                  >
                    {service.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "Lora, serif",
                      opacity: 0.85,
                      textAlign: "center",
                      lineHeight: 1.6,
                    }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            mt: 8,
            fontWeight: 500,
            fontStyle: "italic",
            fontFamily: "Lora, serif",
          }}
        >
          ...and much more ✨
        </Typography>
      </Box>
    </Box>
  );
};

export default ServicesPage;